import React, {useEffect, useState} from 'react'
import { Radio, Tag, message } from 'antd';
import { setUserImport, getUserInfo } from "@root/common/service";
import { store } from "@root/store/index";
import './setRegMethod.scss'
function Index() {

  const [value, setValue] = useState<any>('1');

  const getUser = async()=>{
    const res = await getUserInfo()
    const baseRegistrationStatus = res.institute.baseRegistrationStatus
    setValue(baseRegistrationStatus)
  }
  useEffect(()=>{
    getUser()
  },[])
  const onChange = async(e: any) => {
    console.log('radio checked', e.target.value);
    setValue(e.target.value);
    const {code} = await setUserImport({
      instituteId: store.getState().userInfo.instituteId,
      status: e.target.value
    })
    if(code===200){
      message.success('注册方式切换成功。')
    }
  };

  return (
    <div style={{padding: '50px 0 0 20px',backgroundColor: '#fff', height: '100%'}}>

      <p className='pp'>请选择本院参加培训人员注册方式</p>

      <Radio.Group onChange={onChange} value={value}>
        <Radio value={'1'}>
          <Tag className='aaa' color="#108ee9">统一导入</Tag>
          <br/>
          说明：由医院管理员收集培训人员信息，通过模板导入系统，自动审核通过。
        </Radio>
        <Radio value={'0'} style={{marginTop: '20px'}}>
          <Tag className='aaa' color="#108ee9">自行注册</Tag>
          <br />
          说明：由培训人员登录系统，填写个人信息进行注册，需所在县医院管理员审核通过后，生成学员账号。
        </Radio>        
      </Radio.Group>

    </div>
  )
}

export default Index